
import { useParams , NotesComponent, EntityType } from '../../utils/globalImports';

const ProposalNotes: React.FC = () => {
  const { proposalId } = useParams<{ proposalId: string }>();

  return (
    <NotesComponent
      resourceId={Number(proposalId)}
      title="Proposal"
      entityTypeId={EntityType.Proposal}
      entityId={Number(proposalId)}
      searchbarText="Search for notes/comments"

    />
  );
};

export default ProposalNotes;